import React from 'react'
import PropTypes from 'prop-types'

const lineStyle = {
  fill: 'none',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeMiterlimit: 10,
}

const MenuIcon = ({ customClassName, width, height, fill, lines, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Menu"
    viewBox="0 0 54 54"
  >
    <title id="menu-icon">Menu</title>
    <g>
      <circle fill={fill} cx="27" cy="27" r="27" />
      <line style={lineStyle} stroke={lines} x1="15" y1="16" x2="39" y2="16" />
      <line style={lineStyle} stroke={lines} x1="15" y1="27" x2="39" y2="27" />
      <line style={lineStyle} stroke={lines} x1="15" y1="38" x2="39" y2="38" />
    </g>
  </svg>)

MenuIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  lines: PropTypes.string,
  customClassName: PropTypes.string,
}

MenuIcon.defaultProps = {
  width: 20,
  height: undefined,
  fill: 'blue',
  lines: 'white',
  customClassName: '',
}

export default MenuIcon



// WEBPACK FOOTER //
// ./src/components/icons/Menu.js